module.exports = __webpack_public_path__ + "img/icon-icon-icn-stores.eeb08e8b.svg";